import type { PlanNode } from '@timelog/pm-shared';

/** New nodes get client uuids; codes arrive from the server on save (BR-6). */
export const createPlanNode = (
  kind: PlanNode['kind'],
  name?: string,
  makeId: () => string = () => crypto.randomUUID(),
): PlanNode => ({
  id: makeId(),
  kind,
  name: name ?? 'New task',
  status: 'planned',
  allocations: [],
  children: [],
});
